/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_appsync_graphqlEndpoint": "https://usewc6qpzfh2ngjvadta562rz4.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "flashcardbackend",
            "endpoint": "https://llo0nc8h29.execute-api.us-west-2.amazonaws.com/prod",
            "region": "us-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-west-2:892280ad-9108-4869-9958-12383a0d8ce2",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_6XukysrnL",
    "aws_user_pools_web_client_id": "dildsl7sdsvc7ha62h82b3gsf",
    "oauth": {
        "domain": "flashcardpro-prod.auth.us-west-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/,https://www.flashlearnapp.com/,https://prod.dfpgrhqy4snv0.amplifyapp.com/",
        "redirectSignOut": "http://localhost:3000/,https://www.flashlearnapp.com/,https://prod.dfpgrhqy4snv0.amplifyapp.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "flashlearn-images145003-prod",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
